import { TargetToCreate } from '../interfaces/Target';
import { Stock } from '../interfaces/Stock';

export const getTargetToCreateTemplate = (stocks: Stock[]): TargetToCreate => ({
  symbol: stocks[0]?.symbol ?? '',
  value: stocks[0]?.close ?? 0,
  isGreater: false,
});
